import { render, staticRenderFns } from "./KennenlernenNav.vue?vue&type=template&id=72b11d98&"
import script from "./KennenlernenNav.vue?vue&type=script&lang=js&"
export * from "./KennenlernenNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports